var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modalLoader),expression:"modalLoader"}],staticClass:"spinner-grow modal-loader"},[_c('span',{staticClass:"sr-only"})])
}
var staticRenderFns = []

export { render, staticRenderFns }